(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-current-drop"] && !Shopify.designMode) return;
  try {
    
function hpEnsureDropOverlay() {
  var el = document.querySelector('.hp-drop-hover-title');
  if (!el) {
    el = document.createElement('div');
    el.className = 'hp-drop-hover-title';
    el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);
  }
  return el;
}

document.addEventListener('mouseover', function (event) {
  var tile = event.target.closest('[data-hp-tile-hover-name]');
  if (!tile) return;
  var overlay = hpEnsureDropOverlay();
  overlay.textContent = tile.getAttribute('data-hp-tile-hover-name');
  overlay.classList.add('is-visible');
});

document.addEventListener('mouseout', function (event) {
  var tile = event.target.closest('[data-hp-tile-hover-name]');
  if (!tile) return;
  var related = event.relatedTarget;
  if (related && tile.contains(related)) return;
  var overlay = document.querySelector('.hp-drop-hover-title');
  if (overlay) overlay.classList.remove('is-visible');
});

document.addEventListener('focusin', function (event) {
  var tile = event.target.closest('[data-hp-tile-hover-name]');
  if (!tile) return;
  var overlay = hpEnsureDropOverlay();
  overlay.textContent = tile.getAttribute('data-hp-tile-hover-name');
  overlay.classList.add('is-visible');
});

document.addEventListener('focusout', function (event) {
  var tile = event.target.closest('[data-hp-tile-hover-name]');
  if (!tile) return;
  var overlay = document.querySelector('.hp-drop-hover-title');
  if (overlay) overlay.classList.remove('is-visible');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-duo-tiles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('mousemove', function (event) {
  var area = event.target.closest('[data-hp-tile-cursor-area]');
  if (!area) return;
  var rect = area.getBoundingClientRect();
  var x = event.clientX - rect.left;
  var y = event.clientY - rect.top;
  area.style.setProperty('--hp-cursor-x', x + 'px');
  area.style.setProperty('--hp-cursor-y', y + 'px');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
